import { makeStyles } from '@material-ui/core';
export const useStyles = makeStyles({
    container: {
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '100%',
        padding: '12px',
    },
});
